export const GET_COURSE_ANNOUNCEMENTS_CALL = 'GET_COURSE_ANNOUNCEMENTS_CALL';
export const GET_COURSE_ANNOUNCEMENTS_DONE = 'GET_COURSE_ANNOUNCEMENTS_DONE';
export const GET_COURSE_ANNOUNCEMENTS_FAIL = 'GET_COURSE_ANNOUNCEMENTS_FAIL';
